import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IconName, PIconModule } from '@panaya/ui/p-icon';
import { getAutomationId } from '@panaya/utils';

@Component({
    standalone: true,
    selector: 'p-action-button-floating',
    imports: [PIconModule],
    templateUrl: './p-action-button-floating.component.html',
    styleUrls: ['./p-action-button-floating.component.scss']
})
export class PActionButtonFloatingComponent implements OnInit {
    @Input() iconName!: IconName;
    @Input() ariaLabel = '';
    @Input() disabled = false;

    @Output() buttonClicked: EventEmitter<Event> = new EventEmitter();

    public automationId = '';

    public ngOnInit(): void {
        this.automationId = getAutomationId('p-action-button-floating', this.iconName);
    }

    protected onClick(event: Event): void {
        if (!this.disabled) {
            this.buttonClicked.emit(event);
        }
    }
}
